import React from 'react'
import PropTypes from 'prop-types'


export default function Navbar(props) {

  // const handlechangeDark=()=>{

  // }

  // const handleAbout=()=>{
  //   props.handleAbout();
  // }

  return (
<div>
  <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
        <div className="container-fluid">
           <a className="navbar-brand" >{props.title}</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" >Home</a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link active" onClick={handleAbout} aria-current="page" href="/">About</a>
              </li> */}
            </ul>
      </div>

        <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'} `}>
          <input className="form-check-input" onClick={props.toggleMode} type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
            <label className="form-check-label"  htmlFor="flexSwitchCheckDefault">Dark Mode</label>
        </div>
        {/* <div className={`form-check mx-3 text-${props.mode==='light'?'dark':'light'} style={{color: props.mode==='dark'?'white':'black'}`}>
         <input className="form-check-input" type="checkbox" onClick={handlechangeDark} value="" id="reverseCheck1"/>
         <label className="form-check-label" for="reverseCheck1">For Diff dark Colour</label>
        </div> */}


    </div>
  </nav>
</div>
  )
}


Navbar.prototype={
    title: PropTypes.string,
    abouttext: PropTypes.string
}

Navbar.defaultProps={
    title:"this is Default",
    abouttext:"this  is default"
}